import styled from 'styled-components'

import { TestIDs } from 'test/utils/testIds'

export const Suggestion = styled.div.attrs(_ => ({
  'data-test-id': TestIDs.CONTACT_INFO.SUGGESTION_CONTAINER,
}))`
  padding: 50px 0;
  width: 100%;
  text-align: center;

  @media screen and (max-height: 500px) and (orientation: landscape) {
    padding: 20px 0;
  }
`

export const SuggestionHeader = styled.div.attrs(_ => ({
  'data-test-id': TestIDs.CONTACT_INFO.SUGGESTION_HEADER,
}))`
  font-weight: 600;
  padding: 0 35px;
  margin-bottom: 10px;

  @media screen and (max-height: 500px) and (orientation: landscape) {
    padding: 0 20px;
  }
`

export const SuggestionBody = styled.div.attrs(_ => ({
  'data-test-id': TestIDs.CONTACT_INFO.SUGGESTION_BODY,
}))`
  padding: 0 35px;

  @media screen and (max-height: 500px) and (orientation: landscape) {
    padding: 0 20px;
  }
`

export const SuggestionSeparator = styled.div.attrs(_ => ({
  'data-test-id': TestIDs.CONTACT_INFO.SUGGESTION_SEPARATOR,
}))`
  width: 100%;
  height: 1px;
  border-top: 1px solid #f5f5f5;
  margin: 30px 0;
`
